"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const utils_1 = require("../utils");
const constants_1 = require("../constants");
const Territory_1 = __importDefault(require("./Territory"));
const DefaultOptions_1 = __importDefault(require("./DefaultOptions"));
const File_1 = __importDefault(require("./File"));
/**
 * Renderiza el menú seccion correspon dientede la cabecera
 * @component {jsx} DefaultOptions
 * @component {jsx} Territory
 * @component {jsx} File
 * @component {jsx} ReducedFile
 */
let lastScrollY = -1;
const SCROLL_MOVEMENT_ACCURACY = 60;
class SectionMenu extends react_1.Component {
    constructor(props) {
        super(props);
        this.handleScroll = () => {
            // const { allowFadding, scrollMovement } = this.state;
            const currentScrollY = parseInt(window.scrollY, 10);
            const diff = currentScrollY - lastScrollY;
            const newScrollMovement = diff > 0 ? 'down' : 'up';
            const newAllowFadding = currentScrollY >= constants_1.LIMIT_TO_ALLOW_FADING_SECTION_MENU;
            if (Math.abs(diff) > SCROLL_MOVEMENT_ACCURACY) {
                lastScrollY = currentScrollY;
                this.setState({
                    allowFadding: newAllowFadding,
                    scrollMovement: newScrollMovement,
                });
            }
        };
        this.state = {
            allowFadding: false,
            scrollMovement: 'none',
        };
    }
    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll, { passive: true });
    }
    shouldComponentUpdate(nextProps, nextState) {
        const { isPriority: currentIsPriority, userType: currentUserType } = this.props;
        const { isPriority: nextIsPriority, userType: nextUserType } = nextProps;
        return (currentIsPriority !== nextIsPriority ||
            currentUserType !== nextUserType ||
            this.state.scrollMovement !== nextState.scrollMovement ||
            this.state.allowFadding !== nextState.allowFadding);
    }
    componentWillUnmount() {
        try {
            window.removeEventListener('scroll', this.handleScroll);
        }
        catch (error) {
            console.error(error);
        }
    }
    /**
     * Determina y normaliza el tipo de layout
     * @param {Array} pillsArray Array de pils
     * @param {String} titleBarId (opcional) id del titleBar
     * @returns {String}
     */
    // getKind = (pillsArray, titleBarId) => {
    //   if (Array.isArray(pillsArray)) {
    //     return LAYOUT_TYPES.TERRITORY;
    //   }
    //   if (titleBarId && titleBarId === TITLE_BAR_IDS.TELCO.OUT) {
    //     return LAYOUT_TYPES.REDUCED_FILE;
    //   }
    //   return LAYOUT_TYPES.FILE;
    // };
    render() {
        const { scrollMovement, allowFadding } = this.state;
        const { isPriority, location, segment, isGestor, infoContextApiFailed,
        // scrollMovement,
         } = this.props;
        let { userType, sectionMenu } = this.props;
        if (!sectionMenu || !sectionMenu.public) {
            return null;
        }
        if (infoContextApiFailed) {
            userType = '';
        }
        sectionMenu = sectionMenu.public;
        /* Miro si soy de nuestra área privada */
        if (userType === constants_1.TELCO && (0, utils_1.isTelcoSite)()) {
            sectionMenu = sectionMenu.telco;
        }
        const nohaveProperInfo = !sectionMenu || (!sectionMenu.title && !sectionMenu.defaultOptions);
        // compruebo si tengo info porque sino no hacemos nada
        if (nohaveProperInfo) {
            return null;
        }
        let titleWithH1Tag = true;
        if (sectionMenu && sectionMenu.noHeader) {
            titleWithH1Tag = false;
        }
        const { title, backLink, pillsArray, defaultOptions } = sectionMenu;
        // const kind = this.getKind(pillsArray, titleBarId);
        const movementCss = scrollMovement && allowFadding ? ` scroll-${scrollMovement}` : '';
        if (sectionMenu.type === constants_1.LAYOUT_TYPES.TERRITORY) {
            return (react_1.default.createElement("div", { className: `SectionMenu${movementCss}` },
                react_1.default.createElement(Territory_1.default, { isPriority: isPriority, location: location, title: title, backLink: backLink, pillsArray: pillsArray, segment: segment })));
        }
        if (sectionMenu.type === constants_1.LAYOUT_TYPES.FILE) {
            return (react_1.default.createElement("div", { className: `SectionMenu${movementCss}` },
                react_1.default.createElement(File_1.default, { key: `${title}${backLink}`, isPriority: isPriority, isGestor: isGestor, location: location, title: title, backLink: backLink, segment: segment, titleWithH1Tag: titleWithH1Tag }),
                react_1.default.createElement("div", { id: "Header_SectionMenu_PlaceHolder" })));
        }
        return (react_1.default.createElement("div", { className: `SectionMenu${movementCss}` },
            react_1.default.createElement(DefaultOptions_1.default, { segment: segment, info: defaultOptions, userType: userType })));
    }
}
const mapStateToProps = (state) => ({
    // lastScrollY: state.easyHeader.lastScrollY,
    // scrollMovement: state.easyHeader.scrollMovement,
    sectionMenu: state.header.sectionMenu,
    userType: state.main.context.userType,
    infoContextApiFailed: state.main.context.infoContextApiFailed,
    location: state.header.location,
    isPriority: state.main.context.userPriority,
    // isBuyProcess: state.easyHeader.isBuyProcess,
    segment: state.main.context.pageSegment,
});
exports.default = (0, react_redux_1.connect)(mapStateToProps, null)(SectionMenu);
//# sourceMappingURL=index.js.map